'use strict';
var angular = require('angular');
var EmailPreferenceService = /** @class */ (function () {
    function EmailPreferenceService($http, $log) {
        'ngInject';
        this.$log = $log;
        this.$http = $http;
        // Object to store our user properties
        this.current = null;
    }
    EmailPreferenceService.prototype.addEmailPreference = function (preference) {
        var self = this;
        return this.$http.post('api/account/emailpreferences/' + preference.type)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('add email preference success response.....', response);
            }
            else {
                self.$log.error('add email preference api returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('add email preference api error response.....', response);
            return response;
        });
    };
    EmailPreferenceService.prototype.deleteEmailPreference = function (preference) {
        var self = this;
        return this.$http.delete('api/account/emailpreferences/' + preference.type)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('delete email preference success response.....', response);
            }
            else {
                self.$log.error('delete email preference api returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('delete email preference api error response.....', response);
            return response;
        });
    };
    EmailPreferenceService.prototype.getEmailPreferences = function () {
        return this.$http.get('api/account/emailpreferences');
    };
    EmailPreferenceService.prototype.getAllEmailPreferences = function () {
        return this.$http.get('api/admin/emailpreferences');
    };
    return EmailPreferenceService;
}());
export default EmailPreferenceService;
//# sourceMappingURL=email-preference.service.js.map